import { Charter } from 'anchor-shared/lib/model/entity/charter';

export function buildSMSModalText(charter: Charter): string {
  let text = charter.availabilityStatus;
  if (text === null) {
    text = 'Not Sent';
  }
  return `The current status is: &nbsp;<span class="app-bold-font">${text}</span><br>Are you sure you want to text the boat owner about availability for this boat?`;
}
